import React from 'react';
import styles from './LoginLeftSide.module.css';
import logo from "../../images/ttg_logo.png";

const LoginLeftSide = () => {
  return (
    <div className={styles.leftSide}>
      <div className={styles.imgtextcontainer}>
        <a href="/">
          <img src={logo} alt="Tartigrade Ltd Logo" className={styles.logo} />
        </a>
        Invoicing
        <br />
        Portal
      </div>

    </div>

  );
};

export default LoginLeftSide;